export default __webpack_public_path__ + "static/media/human.cc62639a.svg";